import { Injectable, Output, EventEmitter, Directive } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService } from './authentication.service';
import { RegistrationModalComponent } from '../events/registration/registration-modal.component';

@Directive()
@Injectable()
export class NavigationService {
  public sideBarVisible = false;
  public pageTitle = '';

  @Output() navigatedFromMenu = new EventEmitter<any>();

  constructor(private modalService: NgbModal, private auth: AuthenticationService) {}

  showLogin() {
    const modalRef = this.modalService.open(RegistrationModalComponent, { size: 'lg', ariaLabelledBy: 'modal-basic-title', backdrop: 'static' });
    modalRef.result.then(
      result => {
        this.fetchProfile();
      },
      reason => {}
    );
  }

  reLogin() {
    this.auth.logout();
    const modalRef = this.modalService.open(RegistrationModalComponent, { size: 'lg', ariaLabelledBy: 'modal-basic-title', backdrop: 'static' });
    modalRef.result.then(
      result => {
        this.fetchProfile();
      },
      reason => {}
    );
  }

  triggerNavigationEnded() {
    this.sideBarVisible = false;
    this.navigatedFromMenu.emit();
  }

  fetchProfile() {
    if (this.auth.isLoggedIn()) {
      this.auth.fetchUserProfile().subscribe();
    }
  }
}
